export default __webpack_public_path__ + "static/media/icon_menu-sub.22df396d.svg";